<template>
  <div class="row justify-content-between align-items-center">
    <div class="col">
      <prev-step v-if="!isFirstStep"></prev-step>
    </div>
    <div class="col text-right">
      <next-step v-if="!isLastStep"/>
      <add-to-cart v-if="isLastStep && customband.template === 'fixed'"></add-to-cart>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import routes from '../mixins/routes'

  export default {
    mixins: [routes],

    computed: {
      ...mapState([
        // map this.customband to store.state.customband
        'customband'
      ])
    }
  }
</script>
